import Breadcrumb from './../components/BreadCrumb';
import BlogSection from './../sections/BlogsSection';
import HeadingDetailsSection from './../sections/HeadingDetailsSection';

function BlogsScreen() {
  return (
    <>
        <HeadingDetailsSection heading='Blogs'>
          <Breadcrumb screen='Blogs'/>
        </HeadingDetailsSection>
        <div className='md:mb-20'>
            <BlogSection/>
        </div>
    </>
  );
}

export default BlogsScreen;
